export default "__VITE_ASSET__Gs0WwTjb__"